import React, { useCallback, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import { Application } from "cortex/ui/src/fleet/view/application/model";
import ConfigureParams from "cortex/ui/src/fleet/view/ConfigureParams";
import { Network } from "cortex/ui/src/network/model";
import { getSystemManagedParams } from "cortex/ui/src/redux-store/networks/selectors";
import { PRIORITY } from "cortex/ui/src/ui/parameter-form/utils";
import { RefreshView } from "cortex/ui/src/ui/refresh-view";

interface SubmittedParam {
  appId?: number;
  name: string;
  value: unknown;
}

interface ConfigureNetworkParamsProps {
  addErrorMessage: (msg: string) => void;
  apps: Application[];
  network: Network;
  readonly: boolean;
  updateParams: (args: {
    id: number;
    params: SubmittedParam[];
  }) => Promise<void>;
}

export default function ConfigureNetworkParams({
  network,
  updateParams,
  ...rest
}: ConfigureNetworkParamsProps) {
  const [refresh, setRefresh] = useState(false);
  const { id } = network;

  const successLink = useMemo(() => {
    return <Link to={`/networks/${id}/overview`}>View Network</Link>;
  }, [id]);

  const systemManagedParams = useMemo(() => {
    const params = getSystemManagedParams(network);
    return params ? [...params] : null;
  }, [network]);

  const onSubmit = useCallback(
    (params: SubmittedParam[]) => {
      return updateParams({
        id,
        params,
      }).then(() => {
        setRefresh(true);
      });
    },
    [id, updateParams],
  );

  if (refresh) {
    return <RefreshView />;
  }

  return (
    <ConfigureParams
      {...rest}
      network={network}
      onSubmit={onSubmit}
      priority={PRIORITY.NETWORK}
      showTestingApps={false}
      successLink={successLink}
      systemManagedParams={systemManagedParams}
    />
  );
}
